import { useState } from 'react';

const ADMIN_PASSWORD = '123456';
const STORAGE_KEY = 'cv_admin_auth';

interface AdminGateProps {
  children: React.ReactNode;
}

export default function AdminGate({ children }: AdminGateProps) {
  const [authenticated, setAuthenticated] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (authenticated) {
    return <>{children}</>;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, 'true');
      setAuthenticated(true);
    } else {
      setError('Wrong password');
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-surface-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-surface-900 border border-surface-800 rounded-2xl p-8">
          <h1 className="text-2xl font-bold text-center mb-2">Admin Panel</h1>
          <p className="text-surface-400 text-sm text-center mb-6">Enter password to continue</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="Password"
                autoFocus
                className="w-full px-4 py-3 bg-surface-800 border border-surface-700 rounded-lg text-sm focus:outline-none focus:border-primary/50 text-center tracking-widest"
              />
              {error && <p className="text-red-400 text-xs mt-2 text-center">{error}</p>}
            </div>
            <button
              type="submit"
              className="w-full py-3 bg-primary hover:bg-primary-700 text-white font-medium rounded-lg text-sm transition-colors"
            >
              Enter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
